import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { MainComponent } from './components/main/main.component';
import { setStoreInIdb } from '../utils/idbKeyval';

@Component({
  standalone: true,
  selector: 'ucx-js-root',
  templateUrl: './app.component.html',
  imports: [RouterModule, MainComponent],
})
export class AppComponent {
  constructor(private store: Store) {
    this.store
      .select((state) => state)
      .subscribe((state) => {
        setStoreInIdb(state);
      });
  }
}
